import React from 'react';
import fruits from '../data/fruits'; // Import the fruit data
import ProductCard from '../components/ProductCard';

const Shop = () => {
  return (
    <div style={{ padding: '20px' }}>
      <h2>Our Organic Selection</h2>
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
        {fruits.map((fruit) => (
          <ProductCard key={fruit.Id} product={fruit} />
        ))}
      </div>
    </div>
  );
};

export default Shop;